import admin from './view';

export default [
  {
    path: '/',
    component: admin('/dummy'),
  },
  {
    path: 'status', // 매출현황목록
    component: admin('/sales/status'),
  },
  {
    path: 'dailyStatistics', // 일별매출통계
    component: admin('/sales/dailyStatistics'),
  },
  {
    path: 'monthlyStatistics', // 월별매출통계
    component: admin('/sales/monthlyStatistics'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/sales.js